const decryptEmail = mail => {
  const address = atob(mail);
  window.location.href = `mailto:${address}`;
};

export default decryptEmail;
